import React from 'react';

const BeforeAfter = () => {
  const transformations = [
    {
      title: 'Legacy E-Commerce to Modern Platform',
      before: '2019 - Outdated tech stack, 5s load times',
      after: '2025 - Modern stack, 1.2s load times',
      beforeImage: 'https://images.unsplash.com/photo-1507238691819-a74f79aad7bb?w=300&h=300&fit=crop',
      afterImage: 'https://images.unsplash.com/photo-1460925895917-aeb19be489c7?w=300&h=300&fit=crop',
      metrics: ['250% faster', '150% more conversions', '98% uptime']
    },
    {
      title: 'Desktop-Only to Mobile-First',
      before: '2020 - 90% desktop traffic only',
      after: '2025 - Responsive across all devices',
      beforeImage: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=300&h=300&fit=crop',
      afterImage: 'https://images.unsplash.com/photo-1523293182086-7651a899d37f?w=300&h=300&fit=crop',
      metrics: ['45% mobile traffic', 'Higher engagement', 'Better SEO']
    },
    {
      title: 'Manual Operations to AI-Powered',
      before: '2021 - Manual processes, 40 hours/week',
      after: '2025 - 95% automated with AI',
      beforeImage: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=300&h=300&fit=crop',
      afterImage: 'https://images.unsplash.com/photo-1677442d019cecf8b7a69d03cdc97db8fa78e6d4?w=300&h=300&fit=crop',
      metrics: ['95% time saved', '35% cost reduction', 'Zero errors']
    }
  ];

  return (
    <section id="before-after">
      <div className="section-header">
        <h2 className="section-title">Transformations</h2>
        <p className="section-subtitle">Real before & after stories from our clients</p>
      </div>
      <div className="transformations-grid">
        {transformations.map((item, index) => (
          <div className="transformation-card fade-in" key={index} style={{animationDelay: `${index * 0.1}s`}}>
            <h3>{item.title}</h3>
            <div className="comparison-container">
              <div className="comparison-item">
                <div className="comparison-label">Before</div>
                <img src={item.beforeImage} alt="Before" style={{width: '100%', borderRadius: '12px', marginBottom: '0.5rem'}} />
                <p>{item.before}</p>
              </div>
              <div className="comparison-divider">→</div>
              <div className="comparison-item">
                <div className="comparison-label">After</div>
                <img src={item.afterImage} alt="After" style={{width: '100%', borderRadius: '12px', marginBottom: '0.5rem'}} />
                <p>{item.after}</p>
              </div>
            </div>
            <div className="metrics-list">
              {item.metrics.map((metric, i) => (
                <span key={i} className="metric-tag">✓ {metric}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BeforeAfter;
